import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import {
  makeSelectPageValidations,
  makeSelectDeliveryInfoForm,
  makeSelectSelectedNumber,
  makeSelectDeliveryInfoFormInitialValues,
  makeSelectDeliveryMethods,
  makeSelectDeliveryDates,
  makeSelectCombinedDeliveryDates,
  makeSelectFreeDeliverySlots,
  makeSelectSpecialDeliverySlots,
  makeSelectPostOfficeRegions,
  makeSelectPostOfficeDeliverySlots,
  makeSelectSelectedPostOffice,
  makeSelectIsUploadIDLater,
  makeSelectPostalCodeValidation,
  makeSelectAddressComponentMappings,
  makeSelectCityList,
  makeSelectDistrictList,
  makeSelectStreetList,
  makeSelectStoreList,
  makeSelectPrecheckoutInfo,
  makeSelectIsFetchingData
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import {
  fetchAddressLookup,
  fetchDeliverySlots,
  resetDeliverySlots,
  fetchPostOfficeDeliverySlots,
  fetchAddressComponentMappings,
  findAddressLookup,
  validatePostalCode,
  resetPostalCodeValidation,
  setPostalCodeValidation,
  fetchCityList,
  fetchDistrictList,
  fetchStreetList,
  fetchStoreList,
  resetDistrictList,
  resetStreetList,
  resetStoreList,
  changeFormField
} from "ducks/actions";
import validate, { asyncValidate } from "validations";

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.DELIVERY_INFO_FORM),
  formValues: makeSelectDeliveryInfoForm(),
  preCheckoutData: makeSelectPrecheckoutInfo(),
  selectedNumber: makeSelectSelectedNumber(),
  deliveryMethods: makeSelectDeliveryMethods(),
  deliverySlotDates: makeSelectDeliveryDates(),
  combinedDeliverySlotDates: makeSelectCombinedDeliveryDates(),
  freeDeliverySlotTime: makeSelectFreeDeliverySlots(),
  specialDeliverySlotTime: makeSelectSpecialDeliverySlots(),
  postOfficeRegions: makeSelectPostOfficeRegions(),
  postOfficeDeliverySlots: makeSelectPostOfficeDeliverySlots(),
  selectedPostOffice: makeSelectSelectedPostOffice(),
  uploadIDLater: makeSelectIsUploadIDLater(),
  postalCodeValidation: makeSelectPostalCodeValidation(),
  addressComponentMappings: makeSelectAddressComponentMappings(),
  cityList: makeSelectCityList(),
  districtList: makeSelectDistrictList(),
  streetList: makeSelectStreetList(),
  storeList: makeSelectStoreList(),
  isFetchingDeliverySlots: makeSelectIsFetchingData("deliverySlots"),
  initialValues: makeSelectDeliveryInfoFormInitialValues()
});

export function mapDispatchToProps(dispatch) {
  return {
    fetchPostOfficeDeliverySlots: params => {
      dispatch(fetchPostOfficeDeliverySlots(params));
    },
    fetchDeliverySlots: params => {
      dispatch(fetchDeliverySlots(params));
    },
    resetDeliverySlots: () => dispatch(resetDeliverySlots()),
    fetchAddressLookup: params => {
      dispatch(fetchAddressLookup(params));
    },
    fetchAddressComponentMappings: params => {
      dispatch(fetchAddressComponentMappings(params));
    },
    findAddressLookup: (params, callback) => {
      dispatch(findAddressLookup(params, callback));
    },
    validatePostalCode: (postal_code, field) => {
      dispatch(validatePostalCode({ postal_code }, field));
    },
    resetPostalCodeValidation: field => {
      dispatch(resetPostalCodeValidation(field));
    },
    setPostalCodeValidation: (field, data, loading) => {
      dispatch(setPostalCodeValidation(field, data, loading));
    },
    fetchCityList: params => {
      dispatch(fetchCityList(params));
    },
    fetchDistrictList: params => {
      dispatch(fetchDistrictList(params));
    },
    fetchStreetList: params => {
      dispatch(fetchStreetList(params));
    },
    fetchStoreList: params => {
      dispatch(fetchStoreList(params));
    },
    resetDistrictList: () => {
      dispatch(resetDistrictList());
    },
    resetStreetList: () => {
      dispatch(resetStreetList());
    },
    resetStoreList: () => {
      dispatch(resetStoreList());
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.DELIVERY_INFO_FORM,
          field: field,
          value: value
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.DELIVERY_INFO_FORM,
    destroyOnUnmount: false,
    validate,
    asyncValidate
  }),
  memo
)(SmartRender);
